import React, {
    useState,
    Suspense,
    lazy
} from 'react';
import {
    useDispatch,
    useSelector
} from 'react-redux';
import { 
    nanoid,
    unwrapResult,
} from '@reduxjs/toolkit';
import { Heart, User } from 'tabler-icons-react';
import {
  Card,
  Image,
  Text,
  Group,
  Badge,
  Button,
  ActionIcon,
  createStyles,
  useMantineTheme,
  PasswordInput,
  TextInput,
  Title
} from '@mantine/core';
import logo from '../assets/logo192.png'
import {
    testLogin,
    setUserAuthd
} from '../features/home/homeSlice';


const useStyles = createStyles((theme) => ({
    card: {
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,
        margin: '0 auto',
        width: "80%"
    },
    cardInput: {
        width: "80%"
    },
    titleText: {
        textAlign: "center"
    },
    forgotPw: {
        color: "blue",
        margin: "0 auto",
        textAlign: "center"
    },
    forgotPwContain: {
        textAlign: "center",
        width: "75%",
        margin: "0 auto"
    },
    inputFields: {
        width: '85%',
        margin: '0 auto'
    }
    
}));


export function AuthLogInCard() {
    const { classes } = useStyles();
    const theme = useMantineTheme();
    const dispatch = useDispatch();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const forgotPwClick = () => {
        window.location.href = "https://app.ready.auction/auth/forgotpw"
    }
    
    const attemptLogin = async () => {
        let tempForm = new URLSearchParams();
        tempForm.append("username", username);
        tempForm.append("password", password);
        console.log('starting an attempt to login:')
        let c = await dispatch(testLogin(tempForm))
        .then(unwrapResult)
        .then((res) => {
            //set prefix in the global state and add a selector to retrieve the data
            console.log(res)
            if (res.success == true){
                
                localStorage.setItem('loggedIn', 'true')
                console.log(`value of loggedIn: ${localStorage.getItem('loggedIn')}`)
                
                //window.location.href = 'http://192.168.1.74:8015/next'
                window.location.href = 'https://api.ready.auction/next';
            }else{
                setUsername('');
                setPassword('');
                alert('login issue')
                localStorage.setItem('loggedIn', 'false')
            }
        })
        .catch((rejected_logout) => {
            alert('Issue logging you in please try again')
            localStorage.setItem('loggedIn', 'false')
        })
        
        dispatch(setUserAuthd(true))
        console.log('who is this')
        //unwrapResult(loggedin_success);
        //console.log(loggedin_success);
        //window.location.href = 'http://192.168.1.74:8015/next'
    }

    return (
        <Card shadow="sm" padding="lg" radius="md" withBorder className={classes.card}>
            <Card.Section>
                <Image src={logo} alt="Ready Auction" mx="auto" width={100} height={100}  withPlaceHolder/>
                <Title className={classes.titleText} inline={true}>Ready Auction<br/>Log In</Title>
            </Card.Section>
            <br/>
            <Card.Section>
                <TextInput
                    placeholder="Username"
                    label="Username"
                    className={classes.inputFields}
                    onChange={(e) => setUsername(e.target.value)}
                    value={username}
                    />
                <br/>
                <PasswordInput
                    placeholder="Password"
                    label="Password"
                    className={classes.inputFields}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}/>
            </Card.Section>
            <br/>
            <br/>
            <Button leftIcon={<User />} onClick={attemptLogin} fullWidth={true}>
                Log in
            </Button>
            <br/>
            <br/>
            <br/>
            <div className={classes.forgotPwContain}>
                <a href="https://app.ready.auction/auth/forgotpw" onClick={forgotPwClick} className={classes.forgotPw}>Forgot Password?</a>
            </div>
        </Card>
    );
}
